const fromdataedit = [
  {
    inputdata: "",
    title: "产品线",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "select",
    width: "210px",
    disabled: false,
    lablewith: "60px",
    options: [],
  },
  {
    inputdata: "",
     title: "生产厂商",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "select",
    width: "210px",
    disabled: false,
    lablewith: "100px",
    options: [],
  },
  {
    inputdata: "",
    title: "产品名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    lablewith: "100px",
    disabled: false,
  },
  {
    inputdata: "",
    title: "注册证号",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    lablewith: "60px",
    disabled: false,
  },
  {
    inputdata: "",
    title: "显示名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    lablewith: "100px",
    disabled: false,
  },
  {
    inputdata: "",
    title: "产品类别",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "select",
    width: "210px",
    disabled: false,
    lablewith: "100px",
    options: [],
  },
  {
    inputdata: undefined,
    title: "加价率",
    fontSize: "14px",
    color: "#333333",
    placeholder: "",
    types: "",
    inputtype: "numberComm",
    width: "210px",
    widths: "210px",
    min: 1,
    max: 100,
    lablewith: "60px",
  },
  {
    inputdata: "",
    title: "授权申请名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    lablewith: "100px",
    disabled: false,
  }
];

/*,**/
export default fromdataedit;
